<template>
  <div style="padding-bottom: 50px">
    <Wp_nav_bar
        title="详情">
    </Wp_nav_bar>

    <div v-if="action_datas && action_datas.act_desc">
      <Wp_mini_grow_task_card style="margin-top: 20px">
        <div slot="title" style="text-align: center">
          活动说明
        </div>
        <div slot="content" v-html="action_datas.act_desc.replace(new RegExp('\\n','g'), '<br/>')">
        </div>
      </Wp_mini_grow_task_card>
    </div>

    <div v-if="action_datas">

      <div style="padding: 15px 20px 5px 20px">
        <div style="border: 1px dashed #EE0A24; border-radius: 5px; padding: 5px">
          <div style="text-align: center; font-size: 17px; font-weight: bold">
            {{ action_datas.act_name }}
          </div>
          <div v-if="!actionContent" style="padding-left: 5px">
            <van-loading type="spinner" color="#1989fa" size="20">
              <div slot="default" style="color: #1989fa;font-size: 15px;">
                文案生成中...
              </div>
            </van-loading>
          </div>

          <div v-html="actionContent" style="font-size: 15px; margin-top: 10px"></div>
        </div>
      </div>

      <div style="padding: 10px 20px">
        <Wp_image ref="share_img" v-if="action_datas.act_share_img" :url="action_datas.act_share_img"></Wp_image>
      </div>

      <div class="bottom_button" v-if="showButtons" :style="{bottom: bottom_px}">
        <div style="display: flex">
          <div style="flex: 1; ">
            <van-button size="large"
                        type="danger"
                        plain
                        :disabled="!actionContent"
                        v-clipboard:copy="actionContent.replace(new RegExp('<br/>','g'), '\n')"
                        v-clipboard:success="onCopySuccess"
                        v-clipboard:error="onError"
            >复制文案
            </van-button>
          </div>
          <div style="flex: 1; ">
            <van-button size="large"
                        type="danger"
                        :disabled="!action_datas.act_share_img"
                        @click="clickToShare(action_datas.act_share_img)"
            >分享图片
            </van-button>
          </div>

          <div v-if="action_datas.pop_img" style="flex: 1; padding-left: 10px">
            <van-button size="large"
                        color="orange"
                        @click="makePoster"
            >海报
            </van-button>
          </div>

        </div>
        <van-image-preview
            v-model="showPreview"
            :images="preview_images"
        >
          <!--                        <div slot="">第{{ index }}页</div>-->
        </van-image-preview>
      </div>
    </div>

    <!--        <van-popup v-model="showLoading">-->

    <!--            <van-loading type="spinner" color="#1989fa" vertical-->
    <!--                         style="padding: 30px;">-->
    <!--                <div slot="default" style="text-align: center">加载中...</div>-->
    <!--            </van-loading>-->

    <!--        </van-popup>-->

    <Wp_share_poster_only_img style="background-color: lightgray;"
                              :share-url="poster_url"
                              :share-image="share_img_url"
                              :activeShow="show_share_pop"
    >

    </Wp_share_poster_only_img>

  </div>
</template>

<script>
import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_mini_grow_task_card from '../custom/Wp_mini_grow_task_card'
import Wp_image from '../custom/Wp_image'
import Wp_share_poster_only_img from '../custom/Wp_share_poster_only_img'

export default {
  name: 'Wp_jd_action_info',
  components: { Wp_share_poster_only_img, Wp_image, Wp_mini_grow_task_card, Wp_nav_bar },

  props: {
    params: { type: Object, default: null },//{actId: actId}
    // actId: {type: String, default: ""},
  },

  data () {
    return {
      action_datas: null,
      actionContent: '',
      showLoading: true,

      showPreview: false,
      preview_images: [],

      // bottom_px: "50px",
      bottom_px: '0px',

      showButtons: true,

      poster_url: '',
      share_img_url: '/images/jd_618_poster_1.jpg' + ';/images/jd_618_poster_2.jpg' + ';/images/jd_618_poster_3.jpg',
      show_share_pop: '',

    }
  },

  created () {
    this.initDatas()

    // this.$wx.miniProgram.getEnv(res => {
    //
    //     if (res.miniprogram) {
    //         this.bottom_px = '0px';
    //     }else{
    //         this.bottom_px = '50px';
    //     }
    // });
  },

  watch: {},

  methods: {
    initDatas () {
      // {
      //     act_content: "🔥赶快抢【京享红包】最高888元🎁每天抢3次，抢到就是赚到😄↵🛑记得抢完分享给身边人一起抢！👇↵主会场👉https://u.jd.com/gczJdq↵🎉超市会场👉https://u.jd.com/CBnJ6a"
      //     act_name: "京享红包"
      //     act_share_img: "https://jd.wapg.cn/images/share_pop.jpg"
      //     createtime: "2020-01-13 16:19:03"
      //     end_time: "2020-01-14 00:00:00"
      //     id: "test"
      //     show: 1
      //     start_time: "2020-01-10 00:00:00"
      // }

      let act_id = ''

      if (this.$common.static_action_info_datas) {
        this.action_datas = this.$common.static_action_info_datas
        // if(this.action_datas.act_share_img){
        //     this.share_img_url = this.action_datas.act_share_img;
        // }
        // this.share_img_url = '/images/jd_1111.jpg';
        this.share_img_url = '/images/jd_2021618.jpg'

        this.initActionContentAndLink(this.action_datas.act_content, newContent => {
          this.actionContent = this.formatContent(newContent)
          let temp_str = this.actionContent.substring(this.actionContent.indexOf('https'))
          if (temp_str.indexOf('<') !== -1) {
            this.poster_url = temp_str.substring(0, temp_str.indexOf('<'))
          } else {
            this.poster_url = temp_str
          }

        })
      } else if (this.params && this.params.actId) {
        act_id = this.params.actId
      } else {
        act_id = this.$common.getUrlKey('act')
      }

      if (act_id) {
        let params = {
          id: act_id
        }

        this.$getActionInfo(params, response => {
          if (response && response.code === 200) {
            if (response.data) {
              this.action_datas = response.data
              // this.$log(this.action_datas)
              console.log(this.action_datas)
              // if (this.action_datas.act_share_img) {
              //   this.share_img_url = this.action_datas.act_share_img
              // }
              // this.share_img_url = '/images/jd_1111.jpg';
              this.share_img_url = '/images/jd_2021618.jpg'

              this.initActionContentAndLink(this.action_datas.act_content, newContent => {
                this.actionContent = this.formatContent(newContent)
                let temp_str = this.actionContent.substring(this.actionContent.indexOf('https'))
                if (temp_str.indexOf('<') !== -1) {
                  this.poster_url = temp_str.substring(0, temp_str.indexOf('<'))
                } else {
                  this.poster_url = temp_str
                }
              })
            }

          }
        })
      }
    },

    formatContent (content) {
      if (content) {
        return content.replace(new RegExp('\\n', 'g'), '<br/>')
      }
    },

    initActionContentAndLink (content, fn) {
      if (content) {
        if (content.indexOf('http') !== -1) {
          this.showButtons = true
          let params = {
            content: content,
            pid: this.$common.getUsername(),
            hard: 'yes'
          }

          this.$getChangeLink(params, response => {
            // this.$log("response = " + response);
            if (response && response.code === 200) {

              if (fn) {
                fn(response.content)
              }

            } else if (response.code === 0) {
              this.$dialog.alert({
                message: '文案生成暂无响应'
              })
            } else if (response.code >= 500) {
              if (response.message && response.message.indexOf('pid') !== -1
                  && this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.id) {

                this.$dialog.alert({
                  message: '该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员'
                }).then(() => {
                  this.$common.switchTabMiniProgramPage('../wp_guide/wp_guide')
                })
              } else if (response.temp === 500 && response.message) {//temp为pid为空时的自定义
                this.$dialog.alert({
                  message: '该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员'
                }).then(() => {
                  // this.$common.switchTabMiniProgramPage("../wp_select/wp_select")
                  this.$router.back()
                })
              } else {
                this.$dialog.alert({
                  message: response.message,
                })
              }

            } else if (response.toString().indexOf('Error') != -1) {
              if (response.toString().indexOf('timeout') != -1) {
                this.$dialog.alert({
                  message: '文案生成超时，请返回重试'
                })
              } else {
                this.$dialog.alert({
                  message: '文案生成错误，请返回重试'
                })
              }
            } else {
              this.$dialog.alert({
                title: '文案生成失败',
                message: response.message
              })
            }

          })
          // setTimeout(() => {
          //     this.loading_text = "转链操作较为耗时，请耐心等待..."
          // }, 5000);
        } else {
          this.showButtons = false
          if (fn) {
            fn(content)
          }
        }
        // this.show_paste_sheet_model = false;
      }
    },

    clickToShare (img) {
      this.preview_images = [img]
      this.showPreview = true

      // this.$refs.share_img.$el.focus();
    },

    onCopySuccess () {
      this.$toast.success({
        message: '文案复制成功'
      })
    },

    onError () {
      this.$toast.fail({
        message: '文案复制失败，请尝试手动复制文案'
      })
    },

    makePoster () {
      let timestamp = '_' + Date.parse(new Date())
      this.show_share_pop = timestamp
    },
  }
}
</script>

<style scoped>
.bottom_button {
  padding: 10px 20px 50px 20px;
  position: fixed;
  width: 100%;
  background-color: white;
  /*border-top: 1px solid #999999;*/
  box-shadow: 1px 0px 3px #EE0A24;
}
</style>
